import { getRecordingService } from "@ntconnect/framework/pbx";

export const fetchRecordings = (domain, page, pageSize, search) =>
  getRecordingService().fetchRecordings(domain, page, pageSize, search);

export const fetchRecording = (domain, id) =>
  getRecordingService().fetchRecording(domain, id);

export const fetchRecordingAudio = (domain, id) =>
  getRecordingService().fetchRecordingAudio(domain, id);

export const uploadRecording = (domain, form) =>
  getRecordingService().upload(domain, form);

export const deleteRecording = (domain, id) =>
  getRecordingService().deleteRecording(domain, id);
